import { combineReducers } from "redux";

import { auth } from "./auth.reducer";
import { alert } from "./alert.reducer";
import { whitelabel } from "./whitelabel.reducer";
import { counsellors } from './counsellors.reducer';
import {reports} from './reports.reducer';
import {appVersion} from './appVersion.reducer';
import {languages} from './languages.reducer';
import { patients } from './patient.reducer';
import { appointments } from './appointment.reducer';
import { serviceTypes } from "./serviceType.reducer";
const rootReducer = combineReducers({
  auth,
  whitelabel,
  alert,
  counsellors,
  appVersion,
  reports,
  languages,
  patients,
  appointments,
  serviceTypes
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js